<div class="wrapper" [innerHTML]="translationTemplates[errorMessageType] | translate"></div>
